export class LoggedUser {
  id: string;
  username: string;
  sid: string;
  fullName: string;
  gesemeApiToken?: string;
  permissionScope?: string;
  accessLevel: string;
}
